/*** IMPORTS FROM imports-loader ***/
var define = false;

import baseCreate from './_baseCreate.js';
import extendOwn from './extendOwn.js';

// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
export default function create(prototype, props) {
  var result = baseCreate(prototype);
  if (props) extendOwn(result, props);
  return result;
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/create.js
// module id = 141
// module chunks = 0